import React, { useEffect, useState } from 'react';
import Web3 from 'web3';

import { loadGrumpyContract, loadMeowContract } from '../util/StandardGetters'
import './App.css';
import SideNav from './SideNav'
import Home from './Home'
import Whitepaper from './Whitepaper'
import Swap from './Swap'
import { default as Reclaim, requiredData as reclaimData } from './Reclaim'
import { default as Stake, requiredData as stakeData } from './Stake'
import { default as Vote, requiredData as voteData } from './Vote'
import { default as VoteStatus, requiredData as votestatusData } from './VoteStatus'

import yinYangCat from '../img/yinyang10.png';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

export default function EntryPoint() {

  return (
    <Router>
      <Switch>
        <Route path="/reclaim">
          <Web3Component key='1' requiredContracts={{
            [reclaimData.name]: reclaimData.get
          }}>
            <Reclaim />
          </Web3Component>
        </Route>
        <Route path="/stake">
          <Web3Component key='2' requiredContracts={{
            [stakeData.name]: stakeData.get
          }}>
            <SideNav>
              <Stake />
            </SideNav>
          </Web3Component>
        </Route>
        <Route path="/vote">
          <Web3Component key='vote' requiredContracts={{
            [voteData.name]: voteData.get
          }}>
            <SideNav>
              <Vote />
            </SideNav>
          </Web3Component>
        </Route>
        <Route path="/votestatus">
          <Web3Component key='votestatus' requiredContracts={{
            [votestatusData.name]: votestatusData.get
          }}>
            <SideNav>
              <VoteStatus />
            </SideNav>
          </Web3Component>
        </Route>
        <Route path="/greypaper">
          <SideNav>
            <Whitepaper />
          </SideNav>
        </Route>
        <Route path="/">
          <SideNav>
            <Home />
          </SideNav>
        </Route>
      </Switch>
  </Router>
  );
}

function Web3Component(props) {
  const [loaded, setLoaded] = useState(false);
  const [bcData, setBcData] = useState({});

  async function loadWeb3() {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum)
      await window.ethereum.enable()
    }
    else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider)
    }
    else {
      window.alert('Non ethereum browser detected, try installing metamask or some other provider.')
    }
  }

  async function loadAccounts() {
    return await window.web3.eth.getAccounts();
  }

  useEffect(() => {
    const initWeb3 = async () => {
      await loadWeb3()
      const accounts = await loadAccounts();

      const contracts = {};
      const finished = [];

      for (let key in props.requiredContracts) {
        const p = props.requiredContracts[key](accounts);
        contracts[key] = p;
        finished.push(p);
      }

      await Promise.all(finished);

      for (let key in contracts) {
        contracts[key] = await contracts[key];
      }

      contracts.accounts = accounts;

      setBcData(contracts);
      setLoaded(true);
    };

    initWeb3();
  }, [])

  return (
    <>
      {loaded ?
        React.cloneElement(props.children, { ...bcData })
        :
        <div className='centered'>
          <img src={yinYangCat} className='logoImg rotate' alt=''/>
        </div>
      }
    </>
  );
}
